export enum ServiceTypeIntegrationEnum {
    SendEmail = "Send Email",
    SendTextMessage = "Send Text Message",
    Webhook = "Webhook"
}
